import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-unfetch';
import { buildDataUrl } from '@helper/api';
import { appSetPageData } from '@redux/actions/app';
import { wrapper } from '@redux/store';
import TemplateDefault from '@components/templates/default/default';
import EducationStartStage from '@components/organisms/education/start-stage/educationStartStage';
import ContentBlocks from '@components/organisms/content-blocks/contentBlocks.withRedux';
import LandingTeaser from '@components/organisms/landing-teaser/landingTeaser';

export const getServerSideProps = wrapper.getServerSideProps(store => async ({ locale, query }) => {
  try {
    const { token } = query;

    const response = await fetch(
      `${buildDataUrl(
        `${locale || 'de'}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/bildung${token ? `?token=${token}` : ''}`
      )}`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      if (response.status === 404) {
        return {
          notFound: true
        };
      }
      throw new Error(`Failed to fetch data: ${response.status}`);
    }

    const data = await response.json();

    await store.dispatch(appSetPageData(data));

    return {
      props: {
        data
      }
    };
  } catch (error) {
    console.error('Error fetching data:', error);
    return {
      props: {
        data: null,
        error: error.message
      }
    };
  }
});

function Education({ data = null }) {
  const [darkHeader, setDarkHeader] = useState(true);

  return (
    <TemplateDefault invertedHeader={darkHeader}>
      <EducationStartStage setDarkHeader={setDarkHeader} darkHeader={darkHeader} />
      <ContentBlocks noShareLinks />
      {data?.blogTeaser && data.blogTeaser.teasers.length > 0 ? (
        <LandingTeaser
          teasers={data.blogTeaser.teasers}
          headline={data.blogTeaser.headline}
          linkText={data.blogTeaser.linkText}
          linkTo={data.blogTeaser.linkTo}
        />
      ) : null}
    </TemplateDefault>
  );
}

Education.propTypes = {
  data: PropTypes.shape({
    blogTeaser: PropTypes.shape({
      headline: PropTypes.string,
      teasers: PropTypes.arrayOf(PropTypes.shape()),
      linkText: PropTypes.string,
      linkTo: PropTypes.string
    })
  })
};

export default Education;
